import React from "react";
import { Link } from "react-router-dom";

const RoomNotFound = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center p-4">
      <h1 className="display-4 text-danger mb-3">Room Not Found</h1>
      <p className="lead text-secondary mb-4">
        The room you're trying to access doesn't exist or may have been deleted.
      </p>
      <Link to="/" className="btn btn-primary px-4 py-2">
        Back to Home
      </Link>
    </div>
  );
};

export default RoomNotFound;
